import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useRelocateInventoryObject = () => {
  const http = useHttp()
  const { addError } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (objects: { object_id: number; coordinates: number[][] | number[][][] }[]) =>
      http.put(`/inventory/objects/relocate`, { objects }),
  })

  const relocate = async (
    objects: { object_id: number; coordinates: number[][] | number[][][] }[],
  ) => {
    try {
      await mutation.mutateAsync(objects)
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    relocate,
  }
}
